import { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import useToast from '../../../../hooks/useToast';
import LoaderContext from '../../../../context/LoaderProvider';
import { workReportLineStatus } from '../../../../utils/dataStatus';
import ConditionalWrapper from '../../../ConditionalWrapper/ConditionalWrapper';
import { workReportLinesProp } from '../../../../utils/globalPropTypes';
import { useDetailServiceRequest } from '../../../../context/DetailServiceRequestProvider';
import { postLocationProgramPointService } from '../../../../services/programPointsService';

const STATES_TO_EXCLUDE = [
  workReportLineStatus.enviar,
  workReportLineStatus.aprobar,
  workReportLineStatus.fijar
];

const SendToApproveAllMonthlyLines = (props) => {
  const { workReportLines, newFetch, hasSendToApprovePermissions, selectedDate, setNewFetch } =
    props;

  const today = new Date();
  const selectedDateFormated = new Date(selectedDate);
  const todayOlderThanSelectedDate = today < selectedDateFormated;
  const { setNewToast } = useToast();
  const { setLoader } = useContext(LoaderContext);

  const { updateDetailsforAssignedStatus } = useDetailServiceRequest();

  const fetchToApproveALine = async (lineToApprove) => {
    setLoader(true);
    try {
      const resp = await postLocationProgramPointService(lineToApprove);

      updateDetailsforAssignedStatus();
      setNewFetch(!newFetch);
      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message: resp.mensaje
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message || error.mensaje
      });
    }
  };

  const dataAdapter = workReportLines
    ?.filter(
      (line) =>
        !STATES_TO_EXCLUDE.includes(line.estadoEnum) &&
        line.cantidad !== null &&
        line.cantidad !== '0' &&
        line.cantidad !== 0 &&
        line.habilitaNotificacion &&
        !line.bloqueadoEnSap
    )
    .map((line) => ({
      id: line.idParteDiario,
      cantidad: Number(line.cantidad)
    }));

  return (
    <div className="d-flex justify-content-end mt-4">
      <ConditionalWrapper
        condition={todayOlderThanSelectedDate}
        wrapper={(children) => (
          <OverlayTrigger
            delay={{
              show: 250,
              hide: 400
            }}
            overlay={
              <Tooltip id="button-aprove-all-msds">Linea con fecha posterior a la actual</Tooltip>
            }
            placement="top"
          >
            {children}
          </OverlayTrigger>
        )}
      >
        <div>
          <Button
            className="px-3"
            disabled={
              !dataAdapter.length || !hasSendToApprovePermissions || todayOlderThanSelectedDate
            }
            label="Enviar a aprobar"
            onClick={() => {
              fetchToApproveALine(dataAdapter);
            }}
            type="button"
            variant="primary"
            widthButton="150px"
          />
        </div>
      </ConditionalWrapper>
    </div>
  );
};

SendToApproveAllMonthlyLines.propTypes = {
  hasSendToApprovePermissions: PropTypes.bool.isRequired,
  newFetch: PropTypes.bool,
  selectedDate: PropTypes.string.isRequired,
  setNewFetch: PropTypes.func,
  workReportLines: workReportLinesProp.isRequired
};

SendToApproveAllMonthlyLines.defaultProps = {
  newFetch: false,
  setNewFetch: () => {}
};

export default SendToApproveAllMonthlyLines;
